module.exports = __webpack_public_path__ + "img/delonghi.b0a030f.png";